goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_left_from_line_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_left_from_line_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_left_from_line_svg.default;
